// extracted by mini-css-extract-plugin
module.exports = {"headline":"Visuals_headline__1EUkg","images":"Visuals_images__3kzMR","visuals":"Visuals_visuals__ZVBRd","centered":"Visuals_centered__2rz-0"};